import { useRouter } from "next/navigation";
import React, { useEffect } from "react";
import {
  AutoRefreshEvents,
  WEB_SOCKET_SERVER_URL,
} from "@hub/services/content/auto-refresh.service";

export const AutoRefresh: React.FC<{ children: any }> =
  process.env.NODE_ENV === "development"
    ? ({ children }) => {
        const router = useRouter();

        useEffect(() => {
          const webSocket = new WebSocket(WEB_SOCKET_SERVER_URL);

          webSocket.onmessage = (event) => {
            if (event.data === AutoRefreshEvents.REFRESH) {
              router.refresh();
            }
          };

          return () => {
            webSocket.close();
          };
        }, [router]);

        return children;
      }
    : ({ children }) => {
        return children;
      };
